import {Paddock} from "src/app/infrastructure/moovement-api/models/asset";

export const unassignedAnimalsPaddock: Paddock = {
  id: 'unassigned-animals',
  name: 'Unassigned Animals'
};
